export default (obj, callback) => {
	const keys = Object.keys(obj);
	let returnObj = {};
	for (const key of keys) {
		returnObj = { ...returnObj, ...callback(obj[key], key) };
	}

	return returnObj;
};
